// extracted by mini-css-extract-plugin
export default {"title":"BonusCountdownTimer_title--OVZ","dataItem":"BonusCountdownTimer_dataItem--nu4"};